(function () {

  // Toolbox v2

  var config = (function () {
    var isDebug = document.cookie.indexOf("debugTimestamp=1") !== -1;

    var m = ($("link[href*=frontend_master]").attr("href") || "").match(/^(.+)\/user\/temp\/.+$/),
      cdnPath = m ? m[1] : "";

    return {
      snippetPath: cdnPath + "/user/documents/upload/snippets/",
      cacheBusterParam: "v",
      cacheBuster: null,
      cacheLifetime: 5 * 60000,
      noCache: isDebug,
      tabletSlickBreakpoint: shoptet.config.breakpoints.lg,
      mobileSlickBreakpoint: shoptet.config.breakpoints.sm,
    };
  })();

  var common = (function () {
    function constant(val) {
      return function () {
        return val;
      };
    }

    function identity(val) {
      return val;
    }

    function property(key) {
      return function (obj) {
        return obj[key];
      };
    }

    function matcher(key, value) {
      if (typeof key !== "object")
        return function (obj) {
          return obj[key] === value;
        };

      return function (obj) {
        for (let k in key)
          if (obj[k] !== key[k])
            return false;
        return true;
      };
    }

    function find(arr, predicate) {
      for (let i = 0; i < arr.length; i++)
        if (predicate(arr[i], i))
          return arr[i];
      return null;
    }

    function findIndex(arr, predicate) {
      for (let i = 0; i < arr.length; i++)
        if (predicate(arr[i], i))
          return i;
      return -1;
    }

    function indexBy(arr, iteratee) {
      var obj = {};
      for (let i = 0; i < arr.length; i++)
        obj[iteratee(arr[i], i)] = arr[i];
      return obj;
    }

    function parseNumber(str) {
      return parseFloat(("" + str).replace(/\s+/g, "").replace(",", "."));
    }

    function parsePrice(str) {
      return parseNumber(("" + str).replace(shoptet.config.currencySymbol, "").replace(/(od|ab)\s/, ""));
    }

    function pluralize(n, form1, form24, formMore) {
      n = Math.abs(n);
      return n === 1 ? form1 : (n >= 2 && n <= 4) ? form24 : formMore;
    }

    function slugify(str) {
      var letters = str.trim()
        .toLowerCase()
        .split(""); // Split to array of letters

      var transFrom = "Ă„â€şÄąË‡Ă„Ĺ¤Äąâ„˘ÄąÄľÄ‚ËťÄ‚Ë‡Ä‚Â­Ä‚Â©Ă„ĹąÄąÄ„Ä‚Ĺ‚Ä‚ĹźÄąĹ»ÄąÂĂ„ĹąÄąÄ„";
      var transTo = "escrzyaiedtouundt";
      for (var index, j = 0; j < letters.length; j++) {
        if ((index = transFrom.indexOf(letters[j])) !== -1)
          letters[j] = transTo[index];
      }

      return letters
        .join("")
        .replace(/[^a-z0-9 ]+/g, '')
        .replace(/ +/g, '-');
    }

    function getProperty(obj, path) {
      return path.split(".").reduce(function (cur, key) {
        if (cur === undefined)
          return cur;
        return cur[key];
      }, obj);
    }

    function setProperty(obj, path, value) {
      var parts = path.split("."),
        key;
      while (key = parts.shift()) {
        if (!parts.length) // key is last
          obj[key] = value;
        else
          obj = obj[key];
      }
    }

    function once(fn) {
      var done = false;
      return function () {
        if (done)
          return;
        done = true;
        return fn.apply(this, arguments);
      };
    }

    function debounce(func, wait) {
      var timeout;
      return function () {
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          func.apply({}, args);
        }, wait);
      };
    }

    function throttle(func, wait) {
      var lastCall = 0, lastResult;

      return function () {
        var now = Date.now();
        if (now - lastCall < wait)
          return lastResult;
        lastCall = now;
        return lastResult = func.apply({}, arguments);
      };
    }

    function memoize(cacheKeyResolver, callback, storage) {
      if (!storage)
        storage = sessionStorage;

      function resolveKey(resolver, args, context) {
        if (typeof resolver === "function")
          return resolver.apply(context, args);

        if (Array.isArray(resolver))
          return resolver.map(function (r) {
            return resolveKey(r, args, context);
          }).join(".");

        return "" + resolver;
      }

      var pendingPromises = Object.create({});
      return function () {
        var cacheKey = resolveKey(cacheKeyResolver, arguments, this);
        if (pendingPromises[cacheKey])
          return pendingPromises[cacheKey];
        var cachedValue = storage.getItem(cacheKey);
        if (!config.noCache && cachedValue !== null) {
          cachedValue = JSON.parse(cachedValue);
          if (cachedValue && cachedValue.t && Date.now() <= cachedValue.t + config.cacheLifetime)
            return Promise.resolve(cachedValue.v);
        }

        var promise = Promise.resolve(callback.apply(this, arguments)).then(function (result) {
          try {
            if (!config.noCache && cacheKey)
              storage.setItem(cacheKey, JSON.stringify({ v: result, t: Date.now() }));
          } catch (err) {
            console.error("Unable to write cache key '" + cacheKey + "':", err);
          }

          return result;
        });

        pendingPromises[cacheKey] = promise;
        return promise;
      };
    }

    return {
      constant: constant,
      identity: identity,
      property: property,
      matcher: matcher,
      find: find,
      findIndex: findIndex,
      indexBy: indexBy,
      parseNumber: parseNumber,
      parsePrice: parsePrice,
      pluralize: pluralize,
      slugify: slugify,
      getProperty: getProperty,
      setProperty: setProperty,
      once: once,
      throttle: throttle,
      debounce: debounce,
      memoize: memoize
    };
  })();

  var dom = (function () {
    function trimHtml($el) {
      $el = $($el);
      return $el.each(function () {
        $(this).html($(this).html().trim());
      });
    }

    function getTextShallow($el, noJoin) {
      $el = $($el);

      var parts = [];
      $el.contents().each(function () {
        if (this.nodeType === Node.TEXT_NODE)
          parts.push(this.data);
      });
      return noJoin ? parts : parts.join("");
    }

    function oneTime($el, key) {
      $el = $($el);
      key = "oneTime." + (key || "");
      if (!$el.length || $el.data(key))
        return false;
      $el.data(key, true);
      return true;
    }

    // return true only once if the contents of the given $el didn't change
    function oneTimeContents($el, key) {
      $el = $($el);
      key = "oneTimeContents." + (key || "");
      if (!$el.length)
        return false;
      for (let node of $el[0].childNodes) {
        if (node.nodeType === Node.COMMENT_NODE && node.textContent === key)
          return false;
      }
      $el.append(new Comment(key));
      return true;
    }

    function createModuleInitializer(options) {
      if (typeof options === "function")
        options = { domReady: options }; // compat
      return common.once(function init() {
        if (options.earlyInit && options.earlyInit() === false)
          return;
        $(function () {
          if (options.domReady)
            options.domReady();
        });
        if (options.render)
          hooks.hookAfterDomLoad(options.render, true);
      });
    }
    var whenReady = createModuleInitializer; // compat

    function createElement(tagName, attrs, children) {
      var $el;
      if (tagName.charAt(0) === "<")
        $el = $(tagName);
      else {
        var parts = tagName.split(/([\.#]?[a-zA-Z0-9_:-]+)/).filter(function (part) { return part !== ""; });
        if (parts[0].match(/^\.|#/))
          tagName = "div";
        else
          tagName = parts.shift();
        $el = $(document.createElement(tagName))
        for (let part of parts) {
          if (part.charAt(0) === ".")
            $el.addClass(part.slice(1));
          else if (part.charAt(0) === "#")
            $el.prop("id", part.slice(1));
        }
      }

      if (typeof attrs !== "object" || Array.isArray(attrs)) {
        children = attrs;
        attrs = {};
      }
      $el.attr(attrs);

      if (Array.isArray(children))
        $el.append(children);
      else if (children !== undefined)
        $el.text(children);

      return $el;
    }

    function createTextNode(text) {
      return $(document.createTextNode(text));
    }

    function signalNativeChange($el) {
      $($el).each(function () {
        shoptet.scripts.signalNativeEvent("change", this);
      });
    }

    return {
      trimHtml: trimHtml,
      getTextShallow: getTextShallow,
      oneTime: oneTime,
      oneTimeContents: oneTimeContents,
      whenReady: whenReady,
      createModuleInitializer: createModuleInitializer,
      createElement: createElement,
      createTextNode: createTextNode,
      signalNativeChange: signalNativeChange
    }
  })(), $h = dom.createElement, $t = dom.createTextNode;

  var ajax = (function () {
    var ajaxGetCached = common.memoize(["ajaxCache", common.identity], $.get.bind($));

    function appendCacheBuster(url) {
      if (!url || (!config.noCache && !config.cacheBuster))
        return url;
      var buster = config.cacheBusterParam + "=" + encodeURIComponent(String(config.noCache ? Date.now() : config.cacheBuster));
      if (url.indexOf("?") !== -1)
        return url + "&" + buster;
      return url + "?" + buster;
    }

    function loadFragment(url, noCache) {
      return Promise.resolve(noCache ? $.get(url) : ajaxGetCached(url)).then(function (data) {
        return $(data, shoptet.common.createDocumentFromString(""));
      });
    }

    function loadDocument(url, noCache) {
      return Promise.resolve(noCache ? $.get(url) : ajaxGetCached(url)).then(function (data) {
        return $(shoptet.common.createDocumentFromString(data));
      });
    }

    function load(urls, loader, noCache) {
      if (!loader)
        loader = loadDocument;

      if (typeof urls === "string")
        return loader(urls);

      if (Array.isArray(urls)) { // deduplicate urls
        let promises = {};
        return Promise.all(urls.map(function (url) {
          if (!promises[url])
            promises[url] = loader(url);
          return promises[url];
        }));
      }

      var keys = Object.keys(urls),
        values = keys.map(function (key) {
          return urls[key];
        });

      return load(values, loader).then(function (payloads) {
        var result = {};
        for (var i = 0; i < keys.length; i++)
          result[keys[i]] = payloads[i];
        return result;
      });
    }

    function loadSnippets(urls) {
      return load(urls, function (url) {
        return loadFragment(config.snippetPath + appendCacheBuster(url));
      });
    }

    function withSnippets(urls, callback) {
      return function () {
        var args = [].slice.call(arguments), context = this;
        loadSnippets(urls).then(function (snippets) {
          args.unshift(snippets);
          callback.apply(context, args);
        });
      };
    }

    return {
      appendCacheBuster: appendCacheBuster,
      ajaxGetCached: ajaxGetCached,
      loadFragment: loadFragment,
      loadDocument: loadDocument,
      load: load,
      loadSnippets: loadSnippets,
      withSnippets: withSnippets
    };
  })();

  var hooks = (function () {
    function hookFn(nameOrFn, callback) {
      var origFn = typeof nameOrFn === "string" ? common.getProperty(window, nameOrFn) : nameOrFn;
      if (typeof origFn !== "function")
        throw new Error(nameOrFn + " is not a function");

      function patchedFn() {
        return callback(origFn, arguments, this);
      };
      patchedFn.origFn = origFn;

      if (typeof nameOrFn === "string")
        common.setProperty(window, nameOrFn, patchedFn);
      return patchedFn;
    }

    function hookAfterAjaxDone(url, callback) {
      var urlMatches;
      if (typeof url === "function")
        urlMatches = url;
      else if (url instanceof RegExp)
        urlMatches = function (_url) {
          return url.test(_url);
        };
      else
        urlMatches = function (_url) {
          return url === _url;
        };

      hookFn("$.ajax", function (oldAjax, args, context) {
        var options = args[0],
          ajaxResult = oldAjax.apply(context, args);
        if (urlMatches(options.url, options)) {
          ajaxResult.done = hookFn(ajaxResult.done, function (oldDone, args, context) {
            args = [].slice.call(args);
            args.push(callback);
            return oldDone.apply(context, args);
          });
        }
        return ajaxResult;
      });
    }

    function hookAfterDomLoad(callback, native) {
      var events = ["ShoptetDOMContentLoaded", "ShoptetDOMContentChanged", "TDOMContentLoaded"];
      function handler(e) {
        callback.call(e.target);
      }
      for (let event of events)
        document.addEventListener(event, handler);
      if (native)
        $(callback.bind(null));
    }

    function signalDomLoad(event, element) {
      var globalEvent = "TDOMContentLoaded";
      if (!event) {
        event = globalEvent;
        globalEvent = null;
      }
      shoptet.scripts.signal(event, element, null, globalEvent);
    }

    /** @deprecated */
    function bindEvents(eventNames, callback, now, $el) {
      $el = $($el || document);
      if (!Array.isArray(eventNames))
        eventNames = [eventNames];
      for (let name of eventNames) {
        if (name === "ready")
          $(callback);
        else
          $el[0].addEventListener(name, callback);
      }
      if (now)
        callback();
    }

    return {
      hookFn: hookFn,
      hookAfterAjaxDone: hookAfterAjaxDone,
      hookAfterDomLoad: hookAfterDomLoad,
      signalDomLoad: signalDomLoad,
      bindEvents: bindEvents
    };
  })();

  var sh = (function () {
    function splitVariantCode(code, asObject) {
      var parts = code.split("-"),
        res = asObject ? {} : [];
      for (var i = 0; i < parts.length; i += 2) {
        var pair = [
          common.parseNumber(parts[i]),
          common.parseNumber(parts[i + 1])
        ];
        if (asObject)
          res[pair[0]] = pair[1];
        else
          res.push(pair);
      }
      return res;
    }

    function joinVariantCode(pairs) {
      let tempVariantCode = [];
      if (Array.isArray(pairs)) {
        for (let p of pairs)
          tempVariantCode.push(String(p[0]) + "-" + String(p[1]))
      } else {
        for (let key in pairs)
          tempVariantCode.push(String(key) + "-" + String(pairs[key]));
      }
      tempVariantCode.sort();
      return tempVariantCode.join("-");
    }

    function extractVariantCode($el) {
      var className;
      if ($el instanceof $)
        className = $el.attr("class") || "";
      else
        className = $el;
      for (let c of className.split(" ")) {
        let m = c.trim().match(/^([0-9-]+)$/);
        if (m)
          return m[1];
      }
      return null;
    }

    function getNecessaryVariantData(asObject) {
      const variants = shoptet.variantsSplit.necessaryVariantData || {};
      for (let code in variants) {
        const variant = variants[code];
        if (variant.tb_code)
          continue;

        variant.tb_code = code;
        variant.tb_parameterValues = splitVariantCode(code, false);
        variant.tb_parameterValuesObj = splitVariantCode(code, true);
        variant.tb_price = common.parsePrice(variant.price);
        variant.tb_standardPrice = common.parsePrice(variant.standardPrice);
      }
      return asObject ? variants : Object.values(variants);
    }

    function getSelectedParameterValues($form) {
      if (!$form)
        $form = $(".p-detail");

      const parameterValues = {};
      $form.find('.variant-list .hidden-split-parameter, .variant-list .split-parameter').each(function () {
        const parameterId = $(this).data("parameterId");
        const valueId = $(this).find('input:checked,option:selected').val();
        if (valueId !== '')
          parameterValues[parameterId] = tb.common.parseNumber(valueId);
      });
      return parameterValues;
    }

    return {
      splitVariantCode, joinVariantCode, extractVariantCode,
      getNecessaryVariantData, getSelectedParameterValues
    };
  })();

  var ui = (function () {
    function loadAndOpenModal(url, selector, size) {
      size = size || "lg";
      size = size.slice(0, 1).toUpperCase() + size.slice(1).toLowerCase();

      return ajax.loadDocument(url).then(function ($page) {
        var $content = $page.find(selector);
        if (!$content.length)
          throw new Error("Element not found: " + selector);

        return new Promise(function (resolve) {
          shoptet.modal.open({
            html: shoptet.content.colorboxHeader + $content.html() + shoptet.content.colorboxFooter,
            width: shoptet.config.colorbox["width" + size],
            className: shoptet.config.colorbox["class" + size],
            onComplete: function () {
              $(".colorbox-html-content img").unveil();
              $("body").removeClass(shoptet.config.bodyClasses);
              if ($(".overlay").length > 0) {
                $(".overlay").detach()
              }
              resolve();
            }
          });
        });
      });
    }

    function responsiveSlick(breakpoint, $el, options) {
      $el = $($el).filter(function () {
        return dom.oneTime(this, "responsiveSlick");
      });

      var oldVisible = null;
      function resizeHandler() {
        var visible = $(window).width() <= breakpoint;
        if (visible === oldVisible)
          return;
        if (visible)
          $el.slick(options);
        else if (oldVisible)
          $el.slick("destroy");
        oldVisible = visible;
      }
      $(window).resize(resizeHandler);
      resizeHandler();
    }

    var tabletSlick = responsiveSlick.bind(null, config.tabletSlickBreakpoint),
      mobileSlick = responsiveSlick.bind(null, config.mobileSlickBreakpoint);

    return {
      loadAndOpenModal: loadAndOpenModal,
      responsiveSlick: responsiveSlick,
      tabletSlick: tabletSlick,
      mobileSlick: mobileSlick
    };
  })();

  var toolbox = {
    config: config,
    common: common,
    dom: dom, $h: $h, $t: $t,
    ajax: ajax,
    hooks: hooks,
    sh: sh,
    ui: ui
  };

  window.toolbox = window.tb = toolbox;
  return toolbox;

})();

const ParametricFilterSliders = (function() {
  const config = {
    replaceFilterIds: [],
    enableInputFilterIds: [],
    strictInputs: true,
    showSubmitBtn: true,
    submitOnChange: false,
    injectCss: true,
    fallbackLang: "cs",
    trans: {
      cs: {
        fromValueChanged: val => `Počáteční hodnota byla změněna na ${val}.`,
        toValueChanged: val => `Koncová hodnota byla změněna na ${val}.`,
        fromValueInvalid: (cur, near) =>
          `Počáteční hodnota ${cur} neexistuje.${near.length >= 2 ? ` Nejbližší možné jsou ${near.join(" a ")}.` : near.length > 0 ? ` Nejbližší možná je ${near[0]}.` : ""}`,
        toValueInvalid: (cur, near) =>
          `Koncová hodnota ${cur} neexistuje.${near.length >= 2 ? ` Nejbližší možné jsou ${near.join(" a ")}.` : near.length > 0 ? ` Nejbližší možná je ${near[0]}.` : ""}`,
      },
    }
  };

  let t;
  function getStrings() {
    const dl = getShoptetDataLayer();
    const lang = dl ? dl.language : config.fallbackLang;
    return config.trans[lang] || config.trans[config.fallbackLang] || {};
  }

  function setCheckedValues(baseUrl, urlParam, checkedValues) {
    const regex = new RegExp("([?&])" + urlParam + "=([0-9,]+)");
    let url = baseUrl.replace(regex, "$1").replace(/[?&]+$/, "");

    if(checkedValues.length) {
      url += url.split("?")[1] ? "&" : "?";
      url += urlParam + "=" + checkedValues.map(function(v) { return v.id; }).join(",");
    }
    makeFilterAjaxRequest(url, true, false, event.target, "ShoptetPagePriceFilterChange")
  }

  const lastMsg = {};
  function replaceParametricFilter($section, enableInputs) {
    $section = $($section);

    const $values = $section.find("input[type=checkbox]");
    const filterId = $values.first().data("filterId");

    const sortedValues = $values.map(function() {
        const $el = $(this),
          m = $el.attr("id").match(/([0-9]+)$/);
        return {
          $el: $el,
          valueNumeric: tb.common.parseNumber($el.attr("value")),
          value: $el.attr("value"),
          id: m && tb.common.parseNumber(m[1]),
          disabled: !!$el.prop("disabled"),
          checked: $el.is(":checked"),
          url: $el.data("url")
        };
      }).toArray();
    sortedValues.sort(function(a, b) {
      return a.valueNumeric - b.valueNumeric;
    });

    $section.addClass("has-parametric-slider");

    function setCheckedRange(values) {
      const $input = $values.first(),
        urlParam = $input.data("filterCode") + $input.data("filterId");

      let checkedValues = sortedValues.filter(function(v, i) {
        return i >= values[0] && i <= values[1];
      });
      if(values[0] === minAvailableIndex && values[1] === maxAvailableIndex)
        checkedValues = [];

      setCheckedValues($input.data("url"), urlParam, checkedValues);
    }

    let minAvailableIndex = sortedValues.length-1, maxAvailableIndex = 0, minCheckedIndex = sortedValues.length-1, maxCheckedIndex = 0, hasAvailable = false, hasChecked = false;
    for(let i = 0; i < sortedValues.length; i++) {
      let value = sortedValues[i];
      if(value.checked || !value.disabled) {
        minAvailableIndex = Math.min(minAvailableIndex, i);
        maxAvailableIndex = Math.max(maxAvailableIndex, i);
      }
      if(value.checked) {
        hasChecked = true;
        minCheckedIndex = Math.min(minCheckedIndex, i);
        maxCheckedIndex = Math.max(maxCheckedIndex, i);
      }
    }
    if(!hasAvailable) {
      minAvailableIndex = 0;
      maxAvailableIndex = sortedValues.length-1;
    }
    if(!hasChecked) {
      minCheckedIndex = minAvailableIndex;
      maxCheckedIndex = maxAvailableIndex;
    }

    function extractUnit(s) {
      let m = s.match(/^[0-9,.\s]+([^0-9,.\s].*)$/);
      return m ? m[1] : null;
    }

    function prefixSpace(s) {
      return s ? "\u00a0" + s : "";
    }

    let titleUnit = "", unit = "", m;

    const $title = $section.find("h4>span");
    if($title.length && (m = $title.text().trim().match(/^(.+)\s*\[([^\]]+)\]$/))) {
      $title.text(m[1]);
      unit = titleUnit = m[2];
    } else if(sortedValues.length)
      unit = extractUnit(sortedValues[0].value);

    function sanitizeIndices(indices) {
      return [ Math.max(0, Math.min(indices[0], indices[1])), Math.min(sortedValues.length-1, Math.max(indices[0], indices[1])) ];
    }

    let $slider, $from, $to, $msg, $submitBtn, setDisplayedRange;

    if(enableInputs) {
      let $fromInput, $toInput;

      $from = tb.$h("div.from", [
        tb.$h(".parametric-slider-input-wrapper", [
          $fromInput = tb.$h("input.form-control.form-control-sm.parametric-slider-input", { type: "text", inputmethod: "numeric" }),
          unit ? tb.$h("span.parametric-slider-unit", prefixSpace(unit)) : null
        ])
      ]).toggleClass("has-unit", !!unit);
      $to = tb.$h("div.to", [
        tb.$h(".parametric-slider-input-wrapper", [
          $toInput = tb.$h("input.form-control.form-control-sm.parametric-slider-input", { type: "text", inputmethod: "numeric" }),
          unit ? tb.$h("span.parametric-slider-unit", prefixSpace(unit)) : null
        ])
      ]).toggleClass("has-unit", !!unit);
      $msg = tb.$h("span.parametric-slider-msg").text(lastMsg[filterId] || "");
      $submitBtn = tb.$h("button.btn.parametric-slider-submit-btn", { type: "button" }, "Filtrovat").hide();

      function showMessage(msg) {
        lastMsg[filterId] = msg;
        $msg.text(msg);
      }

      let oldFrom, oldTo;
      setDisplayedRange = function(indices) {
        oldFrom = sortedValues[indices[0]].valueNumeric;
        oldTo = sortedValues[indices[1]].valueNumeric;
        $fromInput.val(oldFrom);
        $toInput.val(oldTo);
      };

      function submitInputs() {
        const fromValueNumeric = tb.common.parseNumber($fromInput.val()) || 0;
        const toValueNumeric = tb.common.parseNumber($toInput.val()) || 0;

        showMessage("");

        if(fromValueNumeric === oldFrom && toValueNumeric === oldTo)
          return;

        let fromIndex, toIndex;
        for(fromIndex = maxAvailableIndex; fromIndex > minAvailableIndex; fromIndex--) {
          if(sortedValues[fromIndex].valueNumeric <= fromValueNumeric)
            break;
        }
        for(toIndex = minAvailableIndex; toIndex < maxAvailableIndex; toIndex++) {
          if(sortedValues[toIndex].valueNumeric >= toValueNumeric)
            break;
        }

        const indices = sanitizeIndices([ fromIndex, toIndex ]);

        let msg = "";
        const newFromValue = sortedValues[indices[0]];
        const newToValue = sortedValues[indices[1]];
        if(config.strictInputs) {
          function buildMsg(msg, cur, index, dir) {
            const nearIndices = [index];
            if(index + dir >= minAvailableIndex && index + dir <= maxAvailableIndex)
              nearIndices.push(index + dir);
            nearIndices.sort();
            return msg(cur + prefixSpace(unit), nearIndices.map(i => sortedValues[i].value + prefixSpace(titleUnit)));
          }

          if(newFromValue.valueNumeric !== fromValueNumeric)
            msg += buildMsg(t.fromValueInvalid, fromValueNumeric, indices[0], 1);
          if(newToValue.valueNumeric !== toValueNumeric)
            msg += buildMsg(t.toValueInvalid, toValueNumeric, indices[1], -1);

          if(msg) {
            showMessage(msg);
            return;
          }
        } else {
          if(newFromValue.valueNumeric !== fromValueNumeric)
            msg += t.fromValueChanged(newFromValue.value + prefixSpace(titleUnit));
          if(newToValue.valueNumeric !== toValueNumeric)
            msg += t.toValueChanged(newToValue.value + prefixSpace(titleUnit));
        }
        showMessage(msg);

        setDisplayedRange(indices);
        setCheckedRange(indices);
        $submitBtn.hide();
      }

      $from.add($to).on("click focus", function(e) {
        e.stopImmediatePropagation();
      }).on("input", function(e) {
        showMessage("");
        if(config.showSubmitBtn)
          $submitBtn.show();
      });
      if(!config.showSubmitBtn || config.submitOnChange)
        $from.add($to).on("change", submitInputs);
        $submitBtn.on("click", submitInputs);
        $(document).on('keypress',function(e) {
          if(e.which == 13) {
            submitInputs()
          }
      });
    } else {
      $from = tb.$h("span.from");
      $to = tb.$h("span.to");
      setDisplayedRange = function(indices) {
        const fromValue = sortedValues[indices[0]];
        const toValue = sortedValues[indices[1]];

        $from.text(fromValue.value + prefixSpace(titleUnit));
        $to.text(toValue.value + prefixSpace(titleUnit));
      };
    }

    $section.find("form").before(tb.$h(".parametric-slider-wrapper", [
      tb.$h(".slider-content", [
        $slider = tb.$h(".parametric-slider")
      ]),
      tb.$h(".slider-header", [ $from, $to ]),
      ($msg || $submitBtn) ? tb.$h(".slider-footer", [ $msg, $submitBtn ]) : null
    ]));

    setDisplayedRange([ minCheckedIndex, maxCheckedIndex ]);

    $slider.slider({
      range: true,
      min: minAvailableIndex,
      max: maxAvailableIndex,
      values: [ minCheckedIndex, maxCheckedIndex],
      slide: function(event, ui) {
        const values = sanitizeIndices(ui.values);
        setDisplayedRange(values);
      },
      stop: function(event, ui) {
        const values = sanitizeIndices(ui.values);
        setDisplayedRange(values);
        setCheckedRange(values);
      }
    });
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit: function() {
      if(!$("body.type-category").length)
        return false;
      t = getStrings();
    },
    domReady: function() {
      if(!config.injectCss)
        return;
      tb.$h("style", `
        .filter-section.has-parametric-slider>form {display:none!important;}
        .parametric-slider-input {max-width:60px;height:2em;text-align:center;}
        .parametric-slider-input-wrapper {display:inline-flex;align-items:center}
      `).appendTo("head");
    },
    render: function() {
      $(".filter-section-parametric").each(function() {
        const filterId = $(this).find("input[type=checkbox]").first().data("filterId");

        if(config.replaceFilterIds.includes(filterId) && tb.dom.oneTime(this, "ParametricFilterSliders"))
          replaceParametricFilter(this, config.enableInputFilterIds.includes(filterId));
      });
    }
  });

  return { init, config };
})();


(function() {

ParametricFilterSliders.config.replaceFilterIds = sliderFilter;
ParametricFilterSliders.config.enableInputFilterIds = sliderFilter;
ParametricFilterSliders.init();

})();